import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Last line of defence: a render error takes out one boundary, not the page.
 * Error boundaries still require a class component in React 19.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Replace with your error reporting sink (Sentry, OTel, ...).
    console.error('Unhandled render error', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      this.props.fallback ?? (
        <p style={{ padding: '4rem 1.5rem', textAlign: 'center' }}>
          Something broke while rendering this page. Please reload.
        </p>
      )
    );
  }
}
